import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TaskSaveService } from '../../task/services/task-save.service';
import { LeaveService } from '../../leave/services/leave.service';
import { AddTimeComponent } from '../../task/components/add-time/add-time.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { AddTaskComponent } from '../../task/components/add-task/add-task.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
    selector: 'app-tareas',
    templateUrl: './tareas.component.html',
    styleUrls: ['./tareas.component.scss'],
    standalone: false
})
export class TareasComponent implements OnInit, OnDestroy {

    ShowPanel = false;
    TareaHouverText: any;
    leaveDetailSubcription: Subscription;
    showAddTaskbtn = false;

    constructor(
        public taskService: TaskSaveService,
        public leaveService: LeaveService,
        public dialog: MatDialog,
        private sharedService: SharedService,
        private clipboard: Clipboard
    ) {
    }

    ngOnInit(): void {
        this.taskService.setPermissionForContextMenu();
        this.leaveDetailSubcription = this.leaveService.SubscribeEmployeeLeaveDetails()
            .subscribe(res => {
                if (res && res.result && res.result.fAlta) {
                    this.ShowPanel = false;
                    this.taskService.IsLoading = false;
                } else {
                    this.ShowPanel = true;
                    this.ValidateAddNewTask();
                    this.taskService.SubcribeTasks();
                }

            }, err => {
                console.error(err);
            });
    }

    ngOnDestroy(): void {
        if (this.ShowPanel) {
            this.taskService.Unsubscribe();
            this.leaveDetailSubcription.unsubscribe();
        }
    }
    copyObservacion(text) {
        this.clipboard.copy(text);
    }

    openAddtaskPopup(): void {
        const dialogRef = this.dialog.open(AddTaskComponent, {
            width: '400px',
            data: this.taskService.BajaId
        });
        dialogRef.componentInstance.taskService.saved.subscribe(() => {
            this.refresh();
        });
    }

    addTimePopup(task): void {
        const dialogRef = this.dialog.open(AddTimeComponent, {
            width: '',
            data: task
        });

        dialogRef.componentInstance.taskService.saved.subscribe(() => {
            this.refresh();
        });
    }

    openConfirmDialogForDelete(task): void {
        const message = `¿Eliminar definitivamente esta tarea?`;
        const dialogData = new ConfirmDialogModel('Confirmar acción', message);
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: dialogData
        });
        dialogRef.afterClosed().subscribe(responce => {
            if (responce) {
                this.callDeleteTask(task);
            }
        });
    }

    refresh(): void {
        this.taskService.PublishTasks(this.taskService.BajaId);
    }

    PrintDocument(task): void {
        task.tareaId = task.TareaId;
        this.taskService.PrintDocument(task);
    }

    deleteTask(task): void {
        const isMarkedTask = task.tipo ? this.taskService.validateMarkedTask(task.tipo) : false;
        if (isMarkedTask) {
            this.callDeleteTask(task);
        }
        else {
            this.openConfirmDialogForDelete(task);
        }
    }

    callDeleteTask(task: any): void {
        this.taskService.deleteTask(task.TareaId).subscribe(res => {
            if (res.code === 0) {
                this.refresh();
                this.sharedService.ShowSnackBar('Borrado exitosamente');
            } else {
                this.sharedService.ShowSnackBar('eliminar falla');
            }
        }, err => {
            this.sharedService.ShowSnackBar('eliminar falla');
        });
    }

    ValidateAddNewTask(): void {
        if (this.taskService.BajaId) {
            this.taskService.validateAddNewTask(this.taskService.BajaId.toString())
                .subscribe(res => {
                    if (res.code === 0)
                        this.showAddTaskbtn = res.result;
                    else {
                        console.error("Server error: " + res.message);
                        this.sharedService.ShowSnackBar('Tareas vlidacion falla');
                    }
                }, err => {
                    console.error(err);
                    this.sharedService.ShowSnackBar('Tareas Vlidacion falla');
                });
        }
    }

}
